var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo_white",
    width: 144,
    height: 100,
    viewBox: "0 0 144 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1923",
    d: "M174 212h-21.037l-44.491-100h21.037z",
    className: "cls-1",
    transform: "translate(-30 -112)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1924",
    fill: "#fff",
    d: "M129.5 112h-21.033L63.976 212h21.038z",
    transform: "translate(-30 -112)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.8
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1925",
    d: "M30 135.637L63.975 212h21.037l-33.975-76.363z",
    className: "cls-1",
    transform: "translate(-30 -112)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.7f315199.svg";
export { ForwardRef as ReactComponent };